import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-matte flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm border border-silver/15 bg-charcoal/30 p-10">
        <div className="flex items-center gap-3 mb-2">
          <Lock className="text-stone" size={20} />
          <span className="eyebrow !mb-0">Admin</span>
        </div>
        <h1 className="heading text-4xl text-cream mb-8">One Of None HQ</h1>
        {error && (
          <p data-testid="login-error" className="text-red-400 text-sm mb-4">{error}</p>
        )}
        <input
          data-testid="login-email"
          type="email"
          required
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="field mb-6"
        />
        <input
          data-testid="login-password"
          type="password"
          required
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="field mb-8"
        />
        <button data-testid="login-submit" disabled={loading} className="btn-primary w-full">
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
